import {
  FilterParams,
  FilterDataMutationParams,
  IFilterState
} from '@/components/ui/filters/store/types';
import * as AT from './actionTypes';
import * as MT from './mutationsTypes';
import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';

/**
 * --------------------------------------------------
 *  Filter Actions
 * --------------------------------------------------
 **/
export const FilterActions: IFilterActions = {
  [AT.FETCH_FILTER_DATA]: async ({ commit, state }, params) => {
    const { name, searchTerm, fetcher } = params;
    const filterState = state[name]?.[searchTerm];
    if (filterState && filterState?.currentPage === filterState?.totalPages) {
      return;
    }

    commit(MT.SET_IS_LOADING, params);

    const currentPage = filterState?.currentPage ?? 0;
    const nextPage = currentPage + 1;

    const response = await fetcher({ ...params, page: nextPage });

    let data = response.data;
    const totalPages = response.paginationMeta.totalPages;
    const totalCount = response.paginationMeta.totalCount;

    const mutationParams: FilterDataMutationParams = {
      currentPage: nextPage,
      data,
      name,
      totalPages,
      totalCount,
      searchTerm
    };
    commit(MT.SET_FILTER_DATA, mutationParams);
    commit(MT.SET_DONE_LOADING, params);
  }
};

/**
 * --------------------------------------------------
 *  Filter Action Context Type
 * --------------------------------------------------
 **/
export type IFilterActionContext = ActionContext<IFilterState, IRootState>;

/**
 * --------------------------------------------------
 *  Filter Actions Type
 * --------------------------------------------------
 **/
export type IFilterActions = ActionTree<IFilterState, IRootState> & {
  [AT.FETCH_FILTER_DATA](
    context: IFilterActionContext,
    params: FilterParams
  ): void;
};
